import { Box, Button, Text, VStack } from "@chakra-ui/react";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputImage } from "components/Atomos/Form/Elements/InputImage";
import { InputText } from "components/Atomos/Form/Elements/InputText";
import { InputTextArea } from "components/Atomos/Form/Elements/InputTextArea";
import { useForm } from "react-hook-form";
import { useAppDispatch, useTypedSelector } from "store/hooks";
import { criarManifestacaoRequest } from "store/modules/ouvidoria/manifestacoes/actions/criarManifestacao";
import { TipoManifestacaoSelect } from "./Selects";
import { ComplaintFormData, complaintSchema } from "./types";
type ComplaintFormProps = {
  latitude: number;
  longitude: number;
  onSuccess: () => void;
};

export function ComplaintForm({
  latitude,
  longitude,
  onSuccess
}: ComplaintFormProps) {
  const { isRequesting } = useTypedSelector(
    (state) => state.ouvidoria.manifestacoes.criarManifestacao
  );
  const dispatch = useAppDispatch();
  const {
    control,
    register,
    formState: { errors },
    handleSubmit
  } = useForm<ComplaintFormData>({
    resolver: yupResolver(complaintSchema)
  });

  const onSubmit = async (data: ComplaintFormData) => {
    dispatch(
      criarManifestacaoRequest({
        respostas: {
          latitude,
          longitude,
          titulo: data.title,
          descricao: data.description,
          tipoManifestacao: data.type,
          image: data.photo
        },
        onSuccess: () => {
          onSuccess();
        }
      })
    );
  };

  return (
    <Box w="full">
      <VStack
        as="form"
        flex={1}
        gap={3}
        alignItems="flex-start"
        onSubmit={handleSubmit(onSubmit)}
      >
        <Text fontSize="lg" fontWeight="medium">
          Criar manifestação
        </Text>
        <InputText
          name="title"
          label="Título"
          w="full"
          register={register}
          error={errors?.title}
        />
        <InputTextArea
          name="description"
          label="Descrição"
          w="full"
          register={register}
          error={errors?.description}
        />

        <TipoManifestacaoSelect
          name="type"
          label="Tipo de manifestação"
          control={control}
          error={errors?.type}
        />

        <InputImage
          name="photo"
          label="Foto"
          w="full"
          control={control}
          error={errors?.photo}
        />

        <Button
          isFullWidth
          colorScheme="main"
          type="submit"
          isLoading={isRequesting}
        >
          Criar manifestação
        </Button>
      </VStack>
    </Box>
  );
}
